import React, { useEffect, useRef, useState } from "react";
const demostrings = ["Bank Account", "Web Payment", " Android & ISO"];
export default function TyperComponent({
  className = "item-text",
  strings = demostrings,
}) {
  const [activeSctingIndex, setActiveSctingIndex] = useState(0);
  const typeitRef = useRef(null);
  const safeStrings = Array.isArray(strings) && strings.length ? strings : demostrings;

  useEffect(() => {
    if (!typeitRef.current) {
      return;
    }

    const visibleEl = typeitRef.current.querySelector(".is-visible");
    if (visibleEl) {
      typeitRef.current.style.width = visibleEl.scrollWidth + "px";
    }

    const reapetTyping = setInterval(() => {
      if (!typeitRef.current) {
        return;
      }

      typeitRef.current.style.width = "0px";
      setTimeout(() => {
        setActiveSctingIndex((pre) => {
          if (pre == safeStrings.length - 1) {
            return 0;
          } else {
            return pre + 1;
          }
        });
        setTimeout(() => {
          if (typeitRef.current) {
            const currentVisibleEl = typeitRef.current.querySelector(".is-visible");
            if (currentVisibleEl) {
              typeitRef.current.style.width = currentVisibleEl.scrollWidth + "px";
            }
          }
        }, 10);
      }, 600);
    }, 3000);

    // Cleanup function to destroy the Typed instance
    return () => {
      clearInterval(reapetTyping);
    };
  }, []);
  return (
    <span ref={typeitRef} className="tf-text s1 cd-words-wrapper typeanimation">
      {safeStrings.map((elm, i) => (
        <span
          key={i}
          className={`${className} ${
            activeSctingIndex == i ? "is-visible" : "is-hidden"
          } `}
        >
          {elm}
        </span>
      ))}
    </span>
  );
}
